import Image from 'next/legacy/image';

import woman1 from '@public/img/our-story/woman-with-raised-arm-bg-neutral.png';
import woman2 from '@public/img/our-story/woman-crossed-arms-bg-dark-blue.png';
import woman3 from '@public/img/our-story/woman-smiling-bg-light-blue.png';
import men from '@public/img/our-story/group-of-men-bg-teal.png';

export const OurAttitudeToFoodImages = (): JSX.Element => (
  <div className="mb-[167px] mt-[45px] flex w-[100%] flex-col md:mb-[177px] md:mt-[60px]">
    <div className="overflow-hidden">
      <div className="ml-[-10%] flex w-[119%] md:ml-[0] md:w-[100%]">
        <div className="w-[41%]">
          <div className="relative w-[100%] overflow-hidden rounded-[32px] pb-[89%] md:rounded-[40px]">
            <div className="absolute h-[100%] w-[100%]">
              <Image
                src={woman1}
                layout="fill"
                objectFit="cover"
                alt="Happy woman"
              />
            </div>
          </div>
        </div>
        <div className="mt-[9%] w-[25%] pl-4 md:pl-6">
          <div className="relative w-[100%] overflow-hidden rounded-[16px] pb-[96%] md:rounded-[40px]">
            <div className="absolute h-[100%] w-[100%]">
              <Image
                src={woman2}
                layout="fill"
                objectFit="cover"
                alt="Happy woman"
              />
            </div>
          </div>
          <div className="relative mt-[16px] w-[100%] overflow-hidden rounded-[16px] pb-[64%] md:mt-[26px] md:rounded-[40px]">
            <div className="absolute h-[100%] w-[100%]">
              <Image
                src={woman3}
                layout="fill"
                objectFit="cover"
                alt="Happy woman"
              />
            </div>
          </div>
        </div>
        <div className="mt-[15%] w-[34%] pl-4 md:mt-[13%] md:pl-6">
          <div className="relative w-[100%] overflow-hidden rounded-[24px] pb-[95%] md:rounded-[40px]">
            <div className="absolute h-[100%] w-[100%]">
              <Image
                src={men}
                layout="fill"
                objectFit="cover"
                alt="Happy men"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
);
